import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "@/shadcn/lib/utils";

// playerdex · registry v1 · shadcn@4.21.0

const Empty = React.forwardRef(function Empty({ className, ...props }, ref) {
  return (
    <div
      data-slot="empty"
      className={cn(
        "gap-4 rounded-2xl border-dashed p-12 flex w-full min-w-0 flex-1 flex-col items-center justify-center text-center text-balance",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});

const EmptyHeader = React.forwardRef(function EmptyHeader(
  { className, ...props },
  ref
) {
  return (
    <div
      data-slot="empty-header"
      className={cn("gap-2 flex max-w-sm flex-col items-center", className)}
      ref={ref}
      {...props}
    />
  );
});

const emptyMediaVariants = cva(
  "mb-2 flex shrink-0 items-center justify-center [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        icon: "bg-muted text-foreground flex size-10 shrink-0 items-center justify-center rounded-xl [&_svg:not([class*='size-'])]:size-5",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

const EmptyMedia = React.forwardRef(function EmptyMedia(
  { className, variant = "default", ...props },
  ref
) {
  return (
    <div
      data-slot="empty-icon"
      data-variant={variant}
      className={cn(emptyMediaVariants({ variant, className }))}
      ref={ref}
      {...props}
    />
  );
});

const EmptyTitle = React.forwardRef(function EmptyTitle(
  { className, ...props },
  ref
) {
  return (
    <div
      data-slot="empty-title"
      className={cn("text-lg font-medium tracking-tight", className)}
      ref={ref}
      {...props}
    />
  );
});

const EmptyDescription = React.forwardRef(function EmptyDescription(
  { className, ...props },
  ref
) {
  return (
    <div
      data-slot="empty-description"
      className={cn(
        "text-sm/relaxed text-muted-foreground [&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:text-primary",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});

const EmptyContent = React.forwardRef(function EmptyContent(
  { className, ...props },
  ref
) {
  return (
    <div
      data-slot="empty-content"
      className={cn(
        "gap-4 text-sm flex w-full max-w-sm min-w-0 flex-col items-center text-balance",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});

export {
  Empty,
  EmptyHeader,
  EmptyTitle,
  EmptyDescription,
  EmptyContent,
  EmptyMedia,
};
